import { useSelector } from 'react-redux';
import { getIsAuthenticatedOAuth } from 'store/user/userSelectors';

export const useIsAuthenticated = () => {
  return useSelector(getIsAuthenticatedOAuth);
};
